import { useMemo } from "react";
import { useAuditoriasAuditoresViewModel } from "../../viewModels/auditorias_auditores_view_model";
import { GenerateAuditoriaAuditoresColumns } from "./columns/auditoria_auditores";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { AuditoresLista } from "../../../domain/models/auditores_lista";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Header } from "./components/header";

export const Auditores = () => {
  const viewModel: any = useAuditoriasAuditoresViewModel();
  const AuditoriaAuditoresListalColumns = useMemo(() => {
    return GenerateAuditoriaAuditoresColumns({
      onActionEditar: viewModel.handleCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteAuditoresModalOpenState,
    });
  }, [
    viewModel.handleCadastroOpenState,
    viewModel.handleDeleteAuditoresModalOpenState,
  ]);
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="AddRounded"
                      size={25}
                      className="text-white"
                    />
                  }
                  onClick={() => viewModel.handleCadastroOpenState(null)}
                >
                  Novo Auditor
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Auditoria
            </Link>
            <Typography className="text-primary-green">
              Auditores Lista
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Auditores Lista
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}
            handleTipoAuditor={viewModel.handleTipoAuditorChange}
            tipoAuditor={viewModel.filters.tipoAuditor}
          />

          <StyledDataGrid
            tableName="auditorias_lista"
            disableColumnMenu={false}
            getRowId={(row: AuditoresLista) => row.IdAuditor}
            columns={AuditoriaAuditoresListalColumns}
            loading={viewModel.loading}
            rows={viewModel.auditoreLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              "& .status-header": {
                backgroundColor: "#AFDFD5",
                color: "#000",
              },
            }}
            autoHeight={true}
            textSize="pequeno"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
          />
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) =>
              viewModel.handleRowsPerPageChange(parseInt(e.target.value))
            }
          />
        </div>
      </form>

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.auditoresDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteAuditoresModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaAuditores}
      />
    </>
  );
};
